import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Breadcrumbs from "../layouts/Breadcrumbs";
import Footer from "../layouts/Footer";
import Headertwo from "../layouts/Headertwo";
import Content from "../sections/About/Content";
import BannerImage from '../../img/img1.jpg'
class About extends Component {
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>Finsa | About Us</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Headertwo />
        <Breadcrumbs breadcrumb={{ pagename: "About Us" }} BannerImage={BannerImage} />
        <Content />

        <Footer />
      </Fragment>
    );
  }
}

export default About;
